import { all, put, select, takeLatest } from "redux-saga/effects";
import { currentEnv } from "~/configs";
import { huyi } from "~/utils/clog";
import AppId from "~/utils/partner";
import * as types from "./types";

const urlLogin = currentEnv.MEDPRO_LOGIN;

function* redirectToMedproId(payload) {
  try {
    const schedulesSelected = yield select(
      state => state.totalData.schedulesSelected
    );
    const bookingFlow = schedulesSelected.length > 0 ? "true" : "";
    const { origin, pathname } = window.location;
    const path = pathname.replace('/umc1', '');
    console.log(path);
    window.localStorage.setItem("loginAt", path);
    yield put({ type: types.SET_CURRENT_URL, payload: path });
    console.log("path: ", path);
    window.location.href = `${urlLogin}/url=${origin}/umc1&partnerId=${AppId}&bookingFlow=${bookingFlow}&path=${path}`;
  } catch (error) {
    huyi({ name: "error-redirectToMedproId", child: error, type: 0 });
  }
}

export default function* watcher() {
  yield all([takeLatest(types.REDIRECT_TO_MEDPRO_ID, redirectToMedproId)]);
}
